import moment from "moment";

export const FULL_DATE_FORMAT = "DD.MM.YYYY";

const buildDate = process.env.REACT_APP_BUILD_DATE;

export const LAST_UPDATED_DATE = buildDate
  ? moment(buildDate).format(FULL_DATE_FORMAT)
  : moment("2026-05-09T00:00:00Z").format(FULL_DATE_FORMAT);
